export default __webpack_public_path__ + "images/0afa1264f780a9a28085960e2170dccb.png";